<template>
    <section class="content">
        <FormGroup label="お支払い方法の選択" name="payment_type"
                type="select" :options="paymentTypes"
                v-model="request.payment_type" :errors="errors" required/>
        <div v-show="request.payment_type === 'stripe'">
            <div class="mx-2">
                <div id="payment-element" ref="paymentElement"></div>
                <p v-if="cardError" style="color:#c00;margin-top:8px;">{{ cardError }}</p>
            </div>
        </div>
        <div v-if="request.payment_type === 'apple_pay' || request.payment_type === 'google_pay'" class="wallet-info pl-4">
            <p>{{ request.payment_type === 'apple_pay' ? 'Apple Pay' : 'Google Pay' }} をご利用いただけるスピーディーな決済方法です。お使いのデバイスやブラウザに応じて、利用可能な決済方法が自動的に表示されます。</p>
        </div>
    </section>
</template>

<script>
import FormGroup from "./FormGroup";
import FormLabel from "./FormLabel";
import FormInput from "./FormInput";
import ErrorText from "../ErrorText";
import BrandLogos from "./BrandLogos";
import CardExpireInput from "./CardExpireInput";
import SecurityCodeInformation from "./SecurityCodeInformation";

export default {
    name: "PaymentForm",
    components: {
        FormGroup,
        FormLabel,
        FormInput,
        ErrorText,
        BrandLogos,
        CardExpireInput,
        SecurityCodeInformation,
    },
    props: {
        request: {
            type: Object,
        },
        payment: {
            type: Object,
        },
        errors: {
            type: Object,
        },
        cardError: {
            type: String,
            default: '',
        },
    },
    computed: {
        paymentTypes() {
            return [
                { value: 'stripe',     label: 'クレジットカード' },
                { value: 'apple_pay',  label: 'Apple Pay' },
                { value: 'google_pay', label: 'Google Pay' },
            ];
        },
        payTimesList() {
            return [
                { value: 1,       label: '1回' },
                { value: 'bonus', label: 'ボーナス払' },
            ];
        },
    },
}
</script>
